import { useCallback } from 'react';
import { FallbackProps } from 'react-error-boundary';
import { Button } from 'yoso';
import { ErrorMessage } from '~/components/Error/Message';
import { t } from '~/components/I18n';

export type ErrorFallbackProps = FallbackProps & {
  className?: string;
};
export const ErrorFallback = ({ className, resetErrorBoundary }: ErrorFallbackProps) => {
  const onButtonClick = useCallback(() => {
    resetErrorBoundary();
  }, [resetErrorBoundary]);

  return (
    <ErrorMessage
      className={className}
      title={t('citizen_error_etc_title')}
      description={t('citizen_error_etc_desc')}>
      <Button color="secondary" size="large" onClick={onButtonClick}>
        {t('citizen_okbutton')}
      </Button>
    </ErrorMessage>
  );
};
